import * as THREE from 'three'
import { Shaders } from './shaders/shaders.js'

//
// Algorithm by Christian Boucheny
// shader code taken and adapted from CloudCompare
//
// see
// https://github.com/cloudcompare/trunk/tree/master/plugins/qEDL/shaders/EDL
// http://www.kitware.com/source/home/post/9
// https://tel.archives-ouvertes.fr/tel-00438464/document p. 115+ (french)

/**
 * EDL 后处理材质，基于深度图与邻域采样增强点云边缘。
 */
export class EyeDomeLightingMaterial extends THREE.RawShaderMaterial {
  /** 邻域采样方向数组，shader 消费 */
  neighbours
  _neighbourCount
  /** 合成不透明度，0-1 */
  opacity = 1.0

  constructor(parameters = {}) {
    super(parameters)

    const uniforms = {
      screenWidth: { type: 'f', value: 0 },
      screenHeight: { type: 'f', value: 0 },
      edlStrength: { type: 'f', value: 1.0 },
      radius: { type: 'f', value: 1.0 },
      neighbours: { type: '2fv', value: [] },
      depthMap: { type: 't', value: null },
      uEDLColor: { type: 't', value: null },
      uEDLDepth: { type: 't', value: null },
      opacity: { type: 'f', value: this.opacity },
    }

    this.setValues({
      uniforms: uniforms,
      vertexShader: this.getDefines() + Shaders['edl.vs'],
      fragmentShader: this.getDefines() + Shaders['edl.fs'],
      lights: false,
    })

    this.neighbourCount = 8
  }

  /**
   * 构造 shader 宏定义串。
   *
   * @returns 包含 `#define NEIGHBOUR_COUNT` 的 GLSL 片段
   */
  getDefines() {
    let defines = ''

    defines += `#define NEIGHBOUR_COUNT ${this.neighbourCount}\n`

    return defines
  }

  /** 重新拼装 shader 源码，触发 needsUpdate。 */
  updateShaderSource() {
    const vs = this.getDefines() + Shaders['edl.vs']
    const fs = this.getDefines() + Shaders['edl.fs']

    this.setValues({
      vertexShader: vs,
      fragmentShader: fs,
    })

    this.uniforms.neighbours.value = this.neighbours

    this.needsUpdate = true
  }

  /** 邻域采样方向数，调整后自动重建 neighbours 数组 */
  get neighbourCount() {
    return this._neighbourCount
  }

  set neighbourCount(value) {
    if (this._neighbourCount !== value) {
      this._neighbourCount = value
      this.neighbours = new Float32Array(this._neighbourCount * 2)
      for (let c = 0; c < this._neighbourCount; c++) {
        this.neighbours[2 * c + 0] = Math.cos((2 * c * Math.PI) / this._neighbourCount)
        this.neighbours[2 * c + 1] = Math.sin((2 * c * Math.PI) / this._neighbourCount)
      }

      this.updateShaderSource()
    }
  }

  /** 释放材质及相关缓存的邻域数据。 */
  dispose() {
    super.dispose()
    this.neighbours = null
    this._neighbourCount = 0
  }
}
